import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSpring, animated } from '@react-spring/web'
import { FiDownload } from 'react-icons/fi'
import { FiFastForward } from 'react-icons/fi'
import { FiRefreshCw } from 'react-icons/fi'
import { FiCheckCircle } from 'react-icons/fi'
import icon5G from './images/icon-5g.svg'
import icon4G from './images/icon-4g.svg'
import icon3G from './images/icon-3g.svg'
import iconAdsl from './images/icon-adsl.svg'
import iconIsdn from './images/icon-isdn.svg'
import icon56k from './images/icon-56k.svg'

function timeRemaining(percentage: number, total: number) {
  let percent = total / 100
  let seconds = Math.ceil(total - percent * percentage)
  return convertSeconds(seconds)
}

function convertSeconds(seconds: number) {
  let days = Math.floor(seconds / (3600 * 24))
  seconds -= days * 3600 * 24
  let hours = Math.floor(seconds / 3600)
  seconds -= hours * 3600
  let minutes = Math.floor(seconds / 60)
  seconds -= minutes * 60

  let secondsString = seconds === 1 ? ' Sekunde ' : ' Sekunden '
  let minutessString = minutes === 1 ? ' Minute ' : ' Minuten '
  let hoursString = hours === 1 ? ' Stunde ' : ' Stunden '
  let daysString = days === 1 ? ' Tag ' : ' Tage '

  let output = days > 0 ? days + daysString : ''
  output += hours > 0 ? hours + hoursString : ''
  output += minutes > 0 ? minutes + minutessString : ''
  output += seconds + secondsString

  return output
}

const LoadingBar = ({
  downloadState,
  counterTime,
  icon,
  year,
  downloadrate,
  s,
  mb,
  decimalplaces,
}: {
  downloadState?: String
  counterTime?: Number
  icon: any
  year: String
  downloadrate: String
  s: any
  mb: Number
  decimalplaces?: any
}) => {
  const [hasCompleted, setHasCompleted] = useState(false)

  const props = useSpring({
    pause: downloadState === 'init',
    reset: downloadState === 'init',
    from: {
      perc: downloadState === 'completed' ? 100 : 0,
      width: downloadState === 'completed' ? '100%' : '0%',
    },
    to: {
      perc:
        downloadState === 'running' || downloadState === 'completed' ? 100 : 0,
      width:
        downloadState === 'running' || downloadState === 'completed'
          ? '100%'
          : '0%',
    },
    config: { duration: downloadState === 'running' ? s * 1000 : 0 },
    onRest: () => {
      if (!hasCompleted) {
        setHasCompleted(true)
      }
    },
    onStart: () => {
      if (hasCompleted) {
        setHasCompleted(false)
      }
    },
    onResolve: () => {
      console.log('onResolve')
      console.log('downloadState:', downloadState)
      if (downloadState === 'completed') {
        setHasCompleted(true)
      } else if (downloadState === 'running') {
        setHasCompleted(true)
      }
    },
  })

  return (
    <div>
      <Downloadconnection>
        <div className='download-wrapper'>
          <div className='connection'>
            <img src={icon} alt='5g' />
            <div className='downloadrate'>{downloadrate}</div>
          </div>
          <div>
            <div className='info'>
              <div className='status'>
                {hasCompleted && (
                  <>
                    <FiCheckCircle />{' '}
                  </>
                )}
                <animated.span className='transferred'>
                  {props.perc.to((value) =>
                    ((800 / 100) * value)
                      .toFixed(
                        downloadState === 'completed' ? 0 : decimalplaces
                      )
                      .replace(/[.,]00$/, '')
                  )}
                </animated.span>
                <span> MB geladen</span>
              </div>
              <div className='year'>{year}</div>
            </div>
            <div className='bar-wrapper'>
              <animated.div
                className={
                  hasCompleted ? 'loading-bar completed' : 'loading-bar'
                }
                style={{
                  width: props.width.to((value) => value),
                  opacity: downloadState === 'init' ? 0 : 1,
                }}
              ></animated.div>
            </div>
            <animated.div className='remaining'>
              {props.perc.to((value) => {
                return downloadState === 'init'
                  ? '\xa0'
                  : value === 100
                  ? 'Ladezeit: ' + convertSeconds(s)
                  : 'Restzeit: ' + timeRemaining(value, s)
              })}
            </animated.div>
          </div>
        </div>
      </Downloadconnection>
    </div>
  )
}

const Downloadconnection = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.4rem;
  padding: 0.4rem 5rem;
  @media only screen and (max-width: 711px) {
    padding: 0.4rem 0;
  }
  .download-wrapper {
    display: grid;
    grid-template-columns: 1fr 5fr;
    @media only screen and (max-width: 711px) {
      grid-template-columns: 1fr 3fr;
    }
    padding-bottom: 1rem;
    border-bottom: 1px solid #333;
    .connection {
      text-align: center;
      padding: 0.8rem 0.6rem 0 0;
      .downloadrate {
        line-height: 1rem;
      }
    }
    .info {
      display: grid;
      grid-template-columns: 5fr 1fr;
      .status {
        padding-top: 0.8rem;
      }
      .year {
        text-align: right;
        font-size: 1.8rem;
        opacity: 0.5;
        margin-bottom: 0.8rem;
      }
    }
    .bar-wrapper {
      background-color: #333;
      border-radius: 0.3rem;
      .loading-bar {
        height: 1.4rem;
        background-color: var(--yellow-main);
        // width: 0%;
        &.completed {
          background-color: var(--petrol-main);
        }
      }
    }
  }
`

const DownloadComparison = ({
  tenant,
  colorMode,
  isMobile,
}: {
  tenant?: Object
  colorMode?: String
  isMobile?: Boolean
}) => {
  const [downloadState, setDownloadState] = useState('init')
  const [counterTime] = useState(685420) // set this to seconds of the longest loadingbar

  function toggleDownload() {
    switch (downloadState) {
      case 'init':
        setDownloadState('running')
        break
      case 'running':
        setDownloadState('completed')
        break
      case 'completed':
        setDownloadState('init')
        break
    }
  }

  return (
    <Downloadcomparison className={isMobile ? 'mobile' : 'desktop'}>
      <h3>Downloadgeschwindigkeiten im Vergleich</h3>
      <h4>Herunterladen eines 800 MB Spielfilms, bei Idealbedingungen</h4>

      <div className='button-wrapper'>
        <Button
          onClick={() => {
            toggleDownload()
          }}
        >
          <>
            {downloadState === 'init' ? (
              <span>
                <FiDownload /> Downloads simulieren
              </span>
            ) : downloadState === 'running' ? (
              <span>
                <FiFastForward /> Downloads abschliessen
              </span>
            ) : downloadState === 'completed' ? (
              <span>
                <FiRefreshCw /> Simulation zurücksetzen
              </span>
            ) : (
              <span>
                <FiDownload /> Downloads simulieren
              </span>
            )}
          </>
        </Button>
      </div>
      <LoadingBar
        icon={icon5G}
        year='2020'
        downloadrate={'3 Gbit/s'}
        mb={800}
        s={2}
        downloadState={downloadState}
        counterTime={counterTime}
        decimalplaces={0}
      />

      <LoadingBar
        icon={icon4G}
        year='2013'
        downloadrate={'150 Mbit/s'}
        mb={800}
        s={43}
        downloadState={downloadState}
        counterTime={counterTime}
        decimalplaces={1}
      />

      <LoadingBar
        icon={icon3G}
        year='2009'
        downloadrate={'42 Mbit/s'}
        mb={800}
        s={152}
        downloadState={downloadState}
        counterTime={counterTime}
        decimalplaces={1}
      />

      <LoadingBar
        icon={iconAdsl}
        year='2000'
        downloadrate={'512 kbit/s'}
        mb={800}
        s={12800}
        downloadState={downloadState}
        counterTime={counterTime}
        decimalplaces={1}
      />

      <LoadingBar
        icon={iconIsdn}
        year='1998'
        downloadrate={'128 kbit/s'}
        mb={800}
        s={51200}
        downloadState={downloadState}
        counterTime={counterTime}
        decimalplaces={1}
      />

      <LoadingBar
        icon={icon56k}
        year='1997'
        downloadrate={'57 kbit/s'}
        mb={800}
        s={117029}
        downloadState={downloadState}
        counterTime={counterTime}
        decimalplaces={1}
      />
    </Downloadcomparison>
  )
}
const Downloadcomparison = styled.div`
  font-family: var(--font-sans-serif);
  h3 {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  h4 {
    margin-bottom: 3rem;
  }
`

const Button = styled.div`
  text-align: center;
  background-color: var(--beige-bright-2);
  padding: 0.6rem 2rem;
  width: fit-content;
  margin: 0 auto 3rem;
  font-weight: 700;
  font-size: 1.5rem;
  font-family: var(--font-sans-serif);
  line-height: 1.7;
  letter-spacing: 0.02rem;
  color: var(--brandblue-main);
  cursor: pointer;
  &:hover {
    background-color: var(--brandblue-main);
    color: #fff;
  }
  svg {
    position: relative;
    top: -0.2rem;
    margin-right: 0.4rem;
  }
`

export default DownloadComparison
